'use client';

import { useEffect } from 'react';

const AsyncStyle = ({ href }: { href: string }) => {
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, [href]);

    return null;
};

export default AsyncStyle;
